var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8.414 17L18.707 6.707a1 1 0 0 0-1.414-1.414L7 15.586V7a1 1 0 0 0-2 0v11a1 1 0 0 0 1 1h11a1 1 0 1 0 0-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }